export type CheckinPageIdType = (typeof CheckinPageIdType)[keyof typeof CheckinPageIdType];
export const CheckinPageIdType = {
  CHECKIN_PASSENGER_ADDITION: 'M021',
  CHECKIN_SEARCH: 'P010',
  CHECKIN_SELECT: 'P020',
  CHECKIN_PASSENGER_INPUT: 'P030',
  CHECKIN_SEATMAP: 'P040',
  CHECKIN_REVIEW: 'P050',
  CHECKIN_MYBOOKING: 'P010',
  CHECKIN_COMPLETED: 'P060',
  BOARDING_PASS_ISSUE: 'M020',
  DIGITAL_CERTIFICATE_REGISTRATION: 'M030',
} as const;
